import React from "react";
import DonutChart from "../../../../components/donut/donut";
import { useSelector } from "react-redux";

const ExistingCustomers = () => {
  const { percentageOfNewVisits, existingVisitsPercentChange, existingVisits } = useSelector(
    (state) => state.attendance.activeClients
  );

  return (
    <DonutChart
      value={100 - percentageOfNewVisits * 100}
      type="Existing"
      dollarValue={existingVisits}
      growth={existingVisitsPercentChange}
      toolTip="Percentage Change from previous month"
    />
  );
};

export default ExistingCustomers;
